import React from "react";

import { TUser, TVehicle, TCatalog } from "types";

export type StoreType = [
  state: any,
  dispatch: React.Dispatch<{
    type: string;
    payload: any;
  }>,
];
export type UserStoreType = [
  state: any,
  dispatch: React.Dispatch<{
    type: string;
    payload: TUser;
  }>,
];

export type TCatalogStore = [
  state: TCatalog,
  dispatch: React.Dispatch<{
    type: string;
    payload: TCatalog;
  }>,
];

export type TVehicles = TVehicle[];

export type TVehiclesStore = [
  state: TVehicles,
  dispatch: React.Dispatch<{
    type: string;
    payload: { catalog: TCatalog; filter: TFilter };
  }>,
];

export enum EOrderType {
  empfohlen = "empfohlen",
  preis_asc = "preis_asc",
  preis_desc = "preis_desc",
  rate_asc = "rate_asc",
  rate_desc = "rate_desc",
  km_asc = "km_asc",
  km_desc = "km_desc",
  erstzulassung_asc = "erstzulassung_asc",
  erstzulassung_desc = "erstzulassung_desc",
}

export type TOrderType = keyof typeof EOrderType;

export type TFilter = {
  // [x: string]: any;
  filter: any;
  reset: any;
  order: TOrderType;
  reducer: any;
  indicator: any;
};

export type TFilterStore = [
  state: TFilter,
  dispatch: React.Dispatch<{
    type: string;
    payload: any;
  }>,
];

export type CookieStoreType = [
  state: { [k: string]: any },
  dispatch: React.Dispatch<{
    type: string;
    payload: CookieType;
  }>,
];

export type CookieType = {
  name: string;
  value?: any;
};

export type TCartVehicle = {
  id: number | string;
  finance: any;
};

export type TCart = {
  vehicles: TCartVehicle[];
};

export type TCartStore = [
  state: TCart,
  dispatch: React.Dispatch<{
    type: string;
    payload: TCartVehicle;
  }>,
];

export type TCheckoutStore = {
  buyerIsOwner: boolean;
  buyer: TUser;
  owner?: TUser;
};

export type TCheckoutProvider = [
  state: TCheckoutStore,
  dispatch: React.Dispatch<{
    type: string;
    payload: any;
  }>,
];
